module.exports = __webpack_public_path__ + "img/4.c16e4db5.png";